import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import MyForm from '../shared/form/MyForm';
import * as types from 'misc/types';
import { getText, trackGA } from 'misc/helpers';

class AgreementNew extends Component {
    render = () => {

        const { agreement, sessions } = this.props;

        let agreementId = 0;
        if (agreement.data && agreement.data[0]) {
            agreementId = agreement.data[0].id;
        }

        let acceptInfo = {
            agree: false,
            agreementId: agreementId,
            customerId: sessions.data.customerId
        }

        return (
            <div className="main-content">
                <div className="complement-content">
                    <img className="complement-logo" src="assets/images/popup/ico_error.svg" alt="" />
                    <h1>{getText('_6_3_TitelUpdatedterms', 'Uppdaterade villkor')}</h1>
                    <p>
                        {getText(
                            '_6_3_text_updatedterms',
                            'Vi har uppdaterat våra användarvillkor. Innan du kan fortsätta måste du acceptera dem på nytt. '
                        )}
                    </p>
                    <MyForm                        
                        name="RegisterForm"
                        sagaAction={types.SAGA_AGREEMENT_PUT}
                        initialValues={acceptInfo}
                        requireAgree
                        agreeBackUrl="/agreement/accept"
                        buttonClasses="button-yellow button-big"
                        submitLabel={getText('_6_3_buttonacceptterms', 'Acceptera')}
                        >
                    </MyForm>
                    <Link className="deny-link" to="/end/accept">
                        {getText('_6_3_buttondenyterms', 'Neka')}
                    </Link>
                </div>
                <img className="logo-bottom-left" src="assets/images/digimail_logo_yellow.svg" alt="" />
            </div>
        );
    };
    
    componentDidMount() {
        trackGA('6.3 Uppdaterade villkor');
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        sessions: state.sessions,
        agreement: state.agreement
    };
};

export default connect(mapStateToProps)(AgreementNew);



// WEBPACK FOOTER //
// ./src/components/views/AgreementNew.js